import { TFormAction } from '~/src/features/lk/popups/ContactPopup/store/reducer';
import { IAction } from '~/src/store';

import { EContactAlertActions } from './index';

export type TSetAction = IAction<EContactAlertActions.SET_ACTION, TFormAction>;

const setAction = (action: TFormAction): TSetAction => ({
    type: EContactAlertActions.SET_ACTION,
    payload: action,
});

export default setAction;
